import { FC } from 'react'

const BulkTicketsPage: FC = () => {
	return (
		<div>
			<h2 className="text-center">Reportes masivos pendientes</h2>
		</div>
	)
}

export { BulkTicketsPage }
